import { Field, Int, ObjectType } from 'type-graphql'

@ObjectType()
export class EntityMeta {
  @Field(() => Int, { nullable: false })
  count: number
}
